import { getIllustrationNamePropType } from '../utils/propTypes/illustrationName';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';
import UIAbstractIllustration from './UIAbstractIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const UIIllustration = props => {
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(UIAbstractIllustration, Object.assign({}, props));
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIIllustration.defaultProps = UIAbstractIllustration.defaultProps;
UIIllustration.propTypes = Object.assign({}, UIAbstractIllustration.propTypes, {
  name: getIllustrationNamePropType().isRequired
});
UIIllustration.displayName = 'UIIllustration';
export default UIIllustration;